module.exports = __webpack_public_path__ + "static/assets/24487245776a9934500df9b68fbdd4f9.svg";